import image1 from '../assets/images/sporti2_gallery/image1.jpg'
import image2 from '../assets/images/sporti2_gallery/image2.jpg'
import image3 from '../assets/images/sporti2_gallery/image3.jpg'
import image4 from '../assets/images/sporti2_gallery/image4.jpg'
import image5 from '../assets/images/sporti2_gallery/image5.jpg'
import image6 from '../assets/images/sporti2_gallery/image6.jpg'
import image7 from '../assets/images/sporti2_gallery/image7.jpg'
import image8 from '../assets/images/sporti2_gallery/image8.jpg'
import image9 from '../assets/images/sporti2_gallery/image9.jpg'
import image10 from '../assets/images/sporti2_gallery/image10.jpg'
const gallerydata = [
   {
    id:1,
    en_title: 'SPORTI-1 Gallery',
    kn_title: 'ಸ್ಪೋರ್ಟಿ-1 ಗ್ಯಾಲರಿ',
    image:'./images/events/SportiGallery/1.JPG',
    images:[
        {
            original:'/images/events/SportiGallery/1.JPG',
            thumbnail:'/images/events/SportiGallery/1.JPG'
        },
        {
            original:'/images/events/SportiGallery/2.JPG',
            thumbnail:'/images/events/SportiGallery/2.JPG'
        },
        {
            original:'/images/events/SportiGallery/3.JPG',
            thumbnail:'/images/events/SportiGallery/3.JPG'
        },
        {
            original:'/images/events/SportiGallery/4.JPG',
            thumbnail:'/images/events/SportiGallery/4.JPG'
        },
        {
            original:'/images/events/SportiGallery/5.JPG',
            thumbnail:'/images/events/SportiGallery/5.JPG'
        },
        {
            original:'/images/events/SportiGallery/6.JPG',
            thumbnail:'/images/events/SportiGallery/6.JPG'
        },
        {
            original:'/images/events/SportiGallery/7.JPG',
            thumbnail:'/images/events/SportiGallery/7.JPG'
        },
        {
            original:'/images/events/SportiGallery/8.JPG',
            thumbnail:'/images/events/SportiGallery/8.JPG'
        },
        {
            original:'/images/events/SportiGallery/9.JPG',
            thumbnail:'/images/events/SportiGallery/9.JPG'
        },
        {
            original:'/images/events/SportiGallery/10.JPG',
            thumbnail:'/images/events/SportiGallery/10.JPG'
        },
        {
            original:'/images/events/SportiGallery/12.JPG',
            thumbnail:'/images/events/SportiGallery/12.JPG'
        },
        {
            original:'/images/events/SportiGallery/13.JPG',
            thumbnail:'/images/events/SportiGallery/13.JPG'
        },
        {
            original:'/images/events/SportiGallery/14.JPG',
            thumbnail:'/images/events/SportiGallery/14.JPG'
        },
        {
            original:'/images/events/SportiGallery/15.JPG',
            thumbnail:'/images/events/SportiGallery/15.JPG'
        },
        {
            original:'/images/events/SportiGallery/16.JPG',
            thumbnail:'/images/events/SportiGallery/16.JPG'
        },
        {
            original:'/images/events/SportiGallery/17.JPG',
            thumbnail:'/images/events/SportiGallery/17.JPG'
        },
        {
            original:'/images/events/SportiGallery/18.JPG',
            thumbnail:'/images/events/SportiGallery/18.JPG'
        },
        {
            original:'/images/events/SportiGallery/19.JPG',
            thumbnail:'/images/events/SportiGallery/19.JPG'
        },
        {
            original:'/images/events/SportiGallery/20.JPG',
            thumbnail:'/images/events/SportiGallery/20.JPG'
        },
        {
            original:'/images/events/SportiGallery/21.JPG',
            thumbnail:'/images/events/SportiGallery/21.JPG'
        },
        {
            original:'/images/events/SportiGallery/22.JPG',
            thumbnail:'/images/events/SportiGallery/22.JPG'
        },
        {
            original:'/images/events/SportiGallery/23.JPG',
            thumbnail:'/images/events/SportiGallery/23.JPG'
        }
    ]
   },
   {
    id:2,
    en_title: 'SPORTI-2 Gallery',
    kn_title: 'ಸ್ಪೋರ್ಟಿ-2 ಗ್ಯಾಲರಿ',
    image:'/images/events/SportiGallery/image5.jpg',
    images:[
        {
            original:'/images/events/SportiGallery/image1.jpg',
            thumbnail:'/images/events/SportiGallery/image1.jpg'
        },
        {
            original:'/images/events/SportiGallery/image2.jpg',
            thumbnail:'/images/events/SportiGallery/image2.jpg'
        },
        {
            original:'/images/events/SportiGallery/image3.jpg',
            thumbnail:'/images/events/SportiGallery/image3.jpg'
        },
        {
            original:'/images/events/SportiGallery/image4.jpg',
            thumbnail:'/images/events/SportiGallery/image4.jpg'
        },
        {
            original:'/images/events/SportiGallery/image5.jpg',
            thumbnail:'/images/events/SportiGallery/image5.jpg'
        },
        {
            original:'/images/events/SportiGallery/image6.jpg',
            thumbnail:'/images/events/SportiGallery/image6.jpg'
        },
        {
            original:'/images/events/SportiGallery/image7.jpg',
            thumbnail:'/images/events/SportiGallery/image7.jpg'
        },
        {
            original:'/images/events/SportiGallery/image8.jpg',
            thumbnail:'/images/events/SportiGallery/image8.jpg'
        },
        {
            original:'/images/events/SportiGallery/image9.jpg',
            thumbnail:'/images/events/SportiGallery/image9.jpg'
        },
        {
            original:'/images/events/SportiGallery/image10.jpg',
            thumbnail:'/images/events/SportiGallery/image10.jpg'
        },
        
    ]
   },

   {
    id:4,
    en_title: 'Superannuation ceremony of Sri. Pratap Reddy, IPS',
    kn_title: 'ಶ್ರೀ. ಪ್ರತಾಪ್ ರೆಡ್ಡಿ, ಐಪಿಎಸ್ ಅವರ ಸೇವಾ ನಿವೃತ್ತಿ ಸಮಾರಂಭ',
    image:'/images/events/superannuation/e1.jpg',
    images:[
        {
            original: "/images/events/superannuation/e2.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_1.jpg",
          },
          {
            original: "/images/events/superannuation/e3.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_2.jpg",
          },
          {
            original: "/images/events/superannuation/e4.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_3.jpg",
          },
          {
            original: "/images/events/superannuation/e5.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_4.jpg",
          },
          {
            original: "/images/events/superannuation/e6.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_5.jpg",
          },
          {
            original: "/images/events/superannuation/e7.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_6.jpg",
          },
          {
            original: "/images/events/superannuation/e8.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_7.jpg",
          },
          {
            original: "/images/events/superannuation/e9.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
        
            
        
    ]
   },
   {
    id:5,
    en_title: '78th Independence Day Celebration',
    kn_title: '78ನೇ ಸ್ವಾತಂತ್ರ್ಯ ದಿನಾಚರಣೆ',
    image:'/images/events/independence/i15.jpg',
    images:[
        {
            original: "/images/events/independence/i12.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          {
            original: "/images/events/independence/i9.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          {
            original: "/images/events/independence/i2.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_2.jpg",
          },
          {
            original: "/images/events/independence/i7.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_7.jpg",
          },
          {
            original: "/images/events/independence/i13.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          
       
          {
            original: "/images/events/independence/i15.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          {
            original: "/images/events/independence/i5.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_5.jpg",
          },
          {
            original: "/images/events/independence/i3.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_3.jpg",
          },
          {
            original: "/images/events/independence/i6.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_6.jpg",
          },

          {
            original: "/images/events/independence/i4.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_4.jpg",
          },
          {
            original: "/images/events/independence/i8.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          {
            original: "/images/events/independence/i10.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          {
            original: "/images/events/independence/i11.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_8.jpg",
          },
          {
            original: "/images/events/independence/i1.jpg",
            thumbnail: "/images/events/MiniTheatreOpening/srwe_2017_1.jpg",
          }   
    ]
   }
]
export default gallerydata;